<template>
    <div>

        <template v-if="!isLoggedIn">
        
            <v-container>
                <v-row justify="center">
                    <v-col style="max-width: 450px;">
                        <v-card>
                            <v-card-title class="text-h5">
                                Sign in
                            </v-card-title>

                            <v-card-subtitle outlined class="mt-6">
                                <v-text-field v-model="username" label="Username" :disabled="isLoggedIn" outlined :error="isError"></v-text-field>
                                <v-text-field type="password" v-model="password" label="Password" :disabled="isLoggedIn" outlined :error="isError"></v-text-field>
                            </v-card-subtitle>

                            <v-card-actions>
                                <v-btn text @click="signIn" :disabled="isLoggedIn">
                                    Sign in
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

        </template>

        <template v-if="isLoggedIn">
        
            <v-container>

                <v-row align="center" style="min-height: calc(100vh - 300px)">
                    <!-- <v-col cols="12" class="text-center">
                        <h1>Forms</h1>
                    </v-col> -->
                    <v-col class="text-center">
                        
                        Delivery Details

                        <download-excel :data="delivery" class="pointer" name="Delivery-Details-Form">
                            <v-icon>mdi-microsoft-excel</v-icon>
                            Download Data
                        </download-excel>
                    </v-col>
                    <v-col class="text-center">
                        Trade Client Order

                        <download-excel :data="trade" class="pointer" name="Trade-Client-Order-Form">
                            <v-icon>mdi-microsoft-excel</v-icon>
                            Download Data
                        </download-excel>
                    </v-col>
                    <v-col class="text-center">
                        Charge Card Authorization

                        <download-excel :data="charges" class="pointer" name="Charge-Card-Authorization-Form">
                            <v-icon>mdi-microsoft-excel</v-icon>
                            Download Data
                        </download-excel>
                    </v-col>
                </v-row>
            </v-container>

        </template>
    </div>
</template>

<script>
import Vue from "vue";
import JsonExcel from "vue-json-excel";
export default {
    components: {
        'download-excel': JsonExcel
    },
    setup() {
        
    },
    data(){
        return {
            json_data: [
                {name: 'a',b: 'b',c: 'c'},
                {name: 'a',b: 'b',c: 'c'},
                {name: 'a',b: 'b',c: 'c'}
            ],
            delivery: [

            ],
            charges: [

            ],
            trade: [

            ],
            username: '',
            password: '',
            user:{

            }
        }
    },
    beforeMount: function () {

    },
    computed: {
        isLoggedIn: function () {
            if(this.user.hasOwnProperty('api_key')){
                this.getData();
                return true
            }
            return false;
        },
        isError: function () {
            if(this.user.hasOwnProperty('error')){
                return true;
            }
            return false;
        }
    },
    methods: {
        signIn: function(){
            fetch('https://www.artlesscms.actstudio.xyz/api/cockpit/authUser?token=cf00a9204acb3ab54e671ca7655e5f', {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user: this.username,
                    password: this.password
                })
            })
            .then(user => user.json())
            .then(user => this.user = user);
        },
        getData: function (){
            fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/DeliveryDetailsForm?token='+this.user.api_key)
            .then(res => res.json())
            .then(res => this.delivery = res.entries);

            fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/ChargeCardAuthorizationForm?token='+this.user.api_key)
            .then(res => res.json())
            .then(res => this.charges = res.entries);

            fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/TradeClientOrderForm?token='+this.user.api_key)
            .then(res => res.json())
            .then(res => this.trade = res.entries);
        }
    }
}
</script>